import React from 'react';
import Icon from '../../Icon';
import { translate } from '../../../Services/translation';

const DescriptionDocuments = ({ documents }) => {
  return (
    <div className="description-documents">
      {documents.map((document) => (
        <a
          className="description-document"
          href={document.value}
          key={document.id}
          target="_blank"
          rel="noreferrer"
          aria-label={`${translate('product.download.document.sc')} ${
            document.args.fileName
          } (${document.args.fileSize})`}
        >
          <Icon
            size={40}
            name="Pdf"
            className="description-document__pdf-icon"
          />
          <div className="description-document__info">
            <div className="description-document__name">
              {document.args.fileName}
            </div>
            <div className="description-document__size">
              {document.args.fileSize}
            </div>
          </div>
          <Icon
            size={24}
            name="Download"
            className="description-document__download-icon"
          />
        </a>
      ))}
    </div>
  );
};

export default DescriptionDocuments;
